import axios from "axios";
import { debug } from "console";
import { parse } from "path";
import React, { SetStateAction } from "react";
import { bool, boolean } from "yup";
import { AXIOS_API_URL } from "../../setup/helpers/apiUrl";
import { RegisterModel, UpdateInfluencerModel } from "../../types";

export const AddNewCustomer = async (model: RegisterModel ) => {
    try {
        await axios.post(`${AXIOS_API_URL}SaveRegisterTblInfluencerData`, model )
        .then(res => {
         
            let resp = JSON.parse(res.data);


            if(resp?.Status == "SUCCESS"){
                alert("Tebrikler yeni kayıt oluşturuldu.");
                window.location.replace(window.location.href)
              }else{
                alert(resp?.Detail)
                
              }
        })
        
    } catch (err) {
        console.log(err)
 
        alert(err)
    }
}

export const GetInfluencerList = async (model: any, setInfluencers: React.Dispatch<SetStateAction<any[] | undefined>>, setIsLoading: React.Dispatch<SetStateAction<boolean>>) => {
    setIsLoading(true)

    try {
        await axios.post(`${AXIOS_API_URL}GetInfluencerListFromRegisterByFilter`, model )
        .then(res => JSON.parse(res.data))
        .then(parse => parse.Detail)
        .then(custs => setInfluencers(custs))
    }  catch (err) {
        console.log(err)
    } finally {
        setIsLoading(false)
    }
    
}

export const GetInfluencerDetails = async (
    RequestId: string | undefined,
    setDetails: React.Dispatch<SetStateAction<any>>,
    mobilePhoneNumber: string | undefined = "") => {
    try {
        var response = {
            status:true,
            detail:"" as string
        };
        
        return await axios.get(`${AXIOS_API_URL}GetInfluencerByRequestId?RequestId=${RequestId}&mobilePhoneNumber=${mobilePhoneNumber}`)
        .then(data => {
           var resp =  JSON.parse(data.data)
            if(data && resp.Status == "SUCCESS"){
                setDetails(resp.Detail)
                response.status = true;
                response.detail = JSON.stringify(resp.Detail);

            }else{
                response.status  =  false
            }
            return response;
        });
    } catch (err) {
        var catchResponse = {
            status:false,
            detail:err
        };

        console.log(err)

        return catchResponse
    }
}


export const SendSMS = async (requestId: number, setSMSConfirm: React.Dispatch<SetStateAction<boolean | undefined>>, setSMSResponseLoading: React.Dispatch<SetStateAction<boolean>>, setSMSModal: React.Dispatch<React.SetStateAction<boolean>>) => {
    setSMSResponseLoading(true)
    await axios.post(`${AXIOS_API_URL}SendSMS`, { requestId })
    .then(async res => {
        if (JSON.parse(res.data).Status === 'FAIL') {
            setSMSConfirm(false)
        } else {
            try {
                await axios.post(`${AXIOS_API_URL}UpdateRequestStatus`, {requestId: requestId, requestStatus: 'W'})
                .then((res) => console.log('Request Status => ', res))
                .then(() => setSMSConfirm(true))
            } catch {
                setSMSConfirm(false)
            }
        }
    })
    .finally(() => {
        console.log('SMS Tamamlandı.')
        setSMSResponseLoading(false)
        setTimeout(() => {
            setSMSModal(false)
        }, 2000)
    })
}

export const UpdateInfluencerDetails = async (model: UpdateInfluencerModel, setIsSaving: React.Dispatch<SetStateAction<boolean>>, setUpdated:any) => {
    try {
        let payload = {
            RequestId: parseInt(model.RequestId),
            Name: model.Name,
            Surname:  model.Surname,
            City:  model.City,
            District:  model.District,
            Quarter:  model.Quarter,
            AvenueName:  model.AvenueName,  
            StreetName:  model.StreetName, 
            BuildingName:  model.BuildingName
        }

        await axios.post(`${AXIOS_API_URL}UpdateRequestEntity`, {...payload} )
        .then(res =>
            {
                let response = JSON.parse(res.data);
                if(response.Status == "SUCCESS"){
                    alert("Güncelleme başarılı.");
                    setUpdated(true);
                }else{
                    alert("Güncelleme işlemi başarısız. " + response.Detail)
                }
            console.log(res)
            })
    } catch (err) {
        console.log(err)
        alert("Bir hata oluştu.")
    } finally {
        setIsSaving(false)
    }
}